import { Helmet } from 'react-helmet-async';
import { 
  getOrganizationSchema, 
  getServiceSchema, 
  getBreadcrumbSchema, 
  getFAQSchema, 
  getLocalBusinessSchema,
  getProductSchema 
} from '../utils/schemaUtils';

/**
 * SchemaMarkup component for adding structured data to pages
 * Helps search engines understand page content for better SEO
 */
const SchemaMarkup = ({ 
  pageType, 
  language = 'en', 
  breadcrumbs = [], 
  faqs = [],
  includeOrganization = true,
  includeLocalBusiness = false,
  includeProduct = false
}) => {
  const schemas = [];

  // Add organization schema
  if (includeOrganization) {
    schemas.push(getOrganizationSchema());
  }

  // Add service schema for specific page types
  if (pageType && pageType !== 'home') {
    schemas.push(getServiceSchema(pageType, language));
  }

  // Add breadcrumb schema
  if (breadcrumbs.length > 0) {
    schemas.push(getBreadcrumbSchema(breadcrumbs, language));
  }

  // Add FAQ schema
  if (faqs.length > 0) {
    schemas.push(getFAQSchema(faqs, language));
  }

  // Add local business schema
  if (includeLocalBusiness) {
    schemas.push(getLocalBusinessSchema());
  }

  // Add product schema
  if (includeProduct) {
    schemas.push(getProductSchema(language));
  }

  return (
    <Helmet>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema, null, 2)
          }}
        />
      ))}
    </Helmet>
  );
};

export default SchemaMarkup;
